import React, { useEffect, useRef } from "react";
import ScrollTrigger from "gsap/ScrollTrigger";
import gsap from "gsap";
import styled from "styled-components";

interface Title {
  title: string;
  textAlign?: string;
  subtitle: string;
}

interface IDivComponent {
  color: string;
  colorSub: string;
  textAlign?: string;
}
interface ITitles extends IDivComponent {
  data: Title;
}

const TitleComponent = styled.div<IDivComponent>`
  display: flex;
  justify-content: center;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  flex-direction: column;

  h1 {
    font-size: 4.5rem;
    color: ${(props) => props.color};
    text-align: center;
    font-weight: 600;
    font-family: "RocknRoll One";
    transition: transform 250ms;
    /* text-align: ${(props) => props.textAlign} */
  }

  h2 {
    width: 60%;
    font-size: 1.1rem;
    /* letter-spacing: .05rem; */
    font-family: "Jost";
    /* font-family: "Josefin Sans", cursive; */
    font-weight: 200;
    color: ${(props) => props.colorSub}; /*  */
    line-height: 2;
  }

  h1:hover {
    transition: transform 250ms;
    transform: translateX(+10px) rotate(+3deg) scale(1.1);
  }

  @media screen and (max-width: 1500px) {
    h1 {
      font-size: 3.5rem;
    }
  }

  @media screen and (max-width: 1300px) {
    h1 {
      font-size: 2.5rem;
    }
  }

  @media screen and (max-width: 1100px) {
  }

  @media screen and (max-width: 500px) {
    h1 {
      font-size: 2.2rem;
    }
  }
`;

const Titles: React.FC<ITitles> = (props) => {
  let refTitle = useRef<HTMLDivElement>(null);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    gsap.from(refTitle.current!, {
      y: 100,
      opacity: 0.1,
      scale: 0.3,
      duration: 0.8,
      delay: 0,
      scrollTrigger: {
        trigger: refTitle.current!,
        toggleActions: "play none none reverse",
      },
    });
  }, []);

  return (
    <TitleComponent
      ref={refTitle}
      color={props.color}
      colorSub={props.colorSub}
      textAlign={props.textAlign}
    >
      <h1>{props.data.title}</h1>
      {props.data.subtitle ? <h2>{props.data.subtitle}</h2> : <></>}
    </TitleComponent>
  );
};

export default Titles;
